import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-cases',
  templateUrl: './manage-cases.component.html',
  styleUrls: ['./manage-cases.component.css']
})
export class ManageCasesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
